export default __webpack_public_path__ + "static/media/fsiRealCase2-en.cd81a03f.jpg";